module KendoWidgets
{
	export class SplitButtonOptions
	{
		width?: number;
		isPrimaryButton?: boolean;

		text?: string;
		items: SplitButtonItem[];
		icon?: string | null;
		imageUrl?: string;
		click?: (e: SplitButtonClickEvent) => void;

		visible?: boolean;
		css?: string;
		wrapper?: string | JQuery | Element;
		open?: (e: SplitButtonOpenEvent) => void;
	}

	export class SplitButton extends kendo.ui.Widget implements KendoWidget
	{
		private _splitButtonMenu: kendo.ui.Menu;

		public controlType(): ControlTypeEnum { return ControlTypeEnum.SplitButton; }

		constructor(element: Element, options?: KendoWidgets.SplitButtonOptions)
		{
			if (options == null)
				options = new KendoWidgets.SplitButtonOptions();

			if (options.items == null) options.items = [];
			if (options.visible == null) options.visible = true;
			if (options.isPrimaryButton == null) options.isPrimaryButton = false;
			if (options.text == null) options.text = "";

			//#region Width
			if (options.width != null)
			{
				$(element).width(options.width);
				$(element).css("display", "inline-block");
			}
			//#endregion

			//#region Parent
			let parentItem: any = {};
			let icon = "";
			if (options.icon != null)
				icon = "<span class='k-icon k-i-" + options.icon + "'></span>";
			else if (options.imageUrl != null)
				icon = "<img src='" + options.imageUrl + "' />";

			parentItem.text = icon + "<span class='spbItem' value='" + element.id + "_ParentItem'>" + options.text + "</span>";
			parentItem.encoded = false;
			//#endregion

			//#region Items
			let menuItems: any[] = [];
			for (let item of options.items.filter(k => k.visible !== false))
			{
				let menuItem: any = {};
				let icon = "";
				if (item.icon != null)
					icon = "<span class='k-icon k-i-" + item.icon + "'></span>";
				else if (item.imageUrl != null)
					icon = "<img style='max-width: 16px; max-height: 16px; margin: -2px 4px 0 -4px;' src='" + item.imageUrl + "' />";

				if (item.text == null)
					item.text = "";
				if (item.value == null)
					item.value = item.text.replace(" ", "").trim();

				let css = "";
				if (item.color != null)
					css += "color: " + item.color + " !important;";
				if (item.backgroundColor != null)
					css += "background-color: " + item.backgroundColor + " !important;";
				if (item.isPrimaryButton == true)
					css += "color: #FFF !important; background-color: #51B3E1 !important;";

				let text = icon + "<span class='spbItem " + ((item.enable === false) ? "splitDisabled" : "")+ "' data-css='" + css + "' value='" + item.value + "'>" + item.text + "</span>";
				if (item.separator == true)
				{
					item.value = "splitButton_separator" + element.id;
					text = "<hr class='splitButton_separator' />";
				}

				menuItem.text = text;
				menuItem.encoded = false;
				menuItems.push(menuItem);
			}
			parentItem.items = menuItems;
			//#endregion

			super(element, options);
			let that = this;

			this._splitButtonMenu = $(element).kendoMenu(
				{
					select: (e) =>
					{
						let options = that.getOptions();

						let splitButtonValue = $(e.item!).find(".spbItem").attr("value");
						let item = options!.items.filter(k => k.value == splitButtonValue)[0];
						let isParent = false;
						if (item == null && splitButtonValue == element.id + "_ParentItem")
						{
							item = parentItem;
							isParent = true;
						}

						let itemElement = $(e.item!);
						if (!isParent)
							itemElement.addClass("splitButtonDisabled");

						//#region Click event
						let clickEvent = new SplitButtonClickEvent();
						clickEvent.item = item;
						clickEvent.isParent = isParent;
						if (item != null && item.click != null && item.enable !== false)
						{
							if (item.confirmationMessage != null && item.confirmationMessage!.length > 0)
								kendo.confirm(item.confirmationMessage!).then(() => item.click!(clickEvent))
							else
								item.click(clickEvent);
						}
						//#endregion

						if (!isParent)
						{
							itemElement.removeClass("splitButtonDisabled");
							setTimeout(() => itemElement.removeClass("splitButtonDisabled"), 2000);
						}
					},
					open: (e) =>
					{
						$(element).find(".k-i-loading").removeClass("k-i-loading");

						for (let elementItem of Array.from($(element).find(".spbItem")))
						{
							if ($(elementItem).attr("data-css") != null && $(elementItem).attr("data-css").length > 0)
								$(elementItem).parent()[0].style.cssText += $(elementItem).attr("data-css");
						}

						if (options!.open != null)
						{
							let openEvent = new SplitButtonOpenEvent();
							openEvent.sender = this;
							options!.open(openEvent);
						}
					},
					dataSource: [parentItem]
				}).data("kendoMenu");

			//#region Visible
			if (options.visible == false)
				window.setTimeout(() => this.visible(false));
			//#endregion

			//#region CSS
			if (options.css != null)
				(element as HTMLElement).style.cssText += options.css;
			//#endregion

			//#region IsPrimaryButton
			if (options.isPrimaryButton)
				$(element).find(".k-menu-link")[0].style.cssText += "color: #FFF !important; background-color: #51B3E1;";
			//#endregion

			//#region Wrapper
			if (options.wrapper != null)
				window.setTimeout(() => this.element.wrap(options!.wrapper!));
			//#endregion
		}

		getOptions()
		{
			return (this.options as KendoWidgets.SplitButtonOptions);
		}

		//#region Visible
		visible(visibleStatus?: boolean)
		{
			if (visibleStatus != null)
			{
				if (visibleStatus)
					this.element.css("display", "inline-flex");
				else
					this.element.css("display", "none");
			}

			return this.element.is(":visible");
		}

		hide()
		{
			this.visible(false);
		}

		show()
		{
			this.visible(true);
		}
		//#endregion

		//#region Append
		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.prependTo(element);
		}
		//#endregion

		//#region Element buttons
		private elementButton(value: string)
		{
			return this.element.find(".k-animation-container .spbItem[value='" + value + "']")[0];
		}

		elementButtonText(value: string, text?: string)
		{
			let elementButton = this.elementButton(value);
			if (elementButton == null)
			{
				this.open();
				window.setTimeout(() => this.element.find(".k-animation-container").hide(), 100);
				window.setTimeout(() =>
				{
					if (text != null && this.elementButton(value) != null)
						this.elementButton(value).textContent = text;

					this.close();
				}, 200);
			}

			if (text != null && elementButton != null)
				elementButton.textContent = text;

			return (elementButton != null) ? elementButton.innerHTML : "";
		}

		showElementButton(value: string)
		{
			this.visibleElementButton(value, true);
		}

		hideElementButton(value: string)
		{
			this.visibleElementButton(value, false);
		}

		visibleElementButton(value: string, state?: boolean)
		{
			let elementButton = this.elementButton(value);
			if (elementButton == null)
			{
				this.open();
				window.setTimeout(() => this.element.find(".k-animation-container").hide(), 100);
				window.setTimeout(() =>
				{
					if (state != null)
					{
						if (state) $(this.elementButton(value)).parent().parent().show();
						else $(this.elementButton(value)).parent().parent().hide();
					}
					this.close();
				}, 200);
			}

			if (state != null)
			{
				if (state) $(this.elementButton(value)).parent().parent().show();
				else $(this.elementButton(value)).parent().parent().hide();
			}
			return $(this.elementButton(value)).parent().parent().is(":visible");
		}

		enableElementButton(value: string)
		{
			let options = this.getOptions();

			let elementButton = this.elementButton(value);
			if (elementButton == null)
			{
				this.open();
				window.setTimeout(() => this.element.find(".k-animation-container").hide(), 100);
				window.setTimeout(() =>
				{
					$(this.elementButton(value)).removeClass("splitDisabled");
					let item = options.items.filter(k => k.value == value)[0];
					let itemIndex = options.items.indexOf(item);
					options.items[itemIndex].enable = true;

					this.close();
				}, 200);
			}
			else
			{
				$(this.elementButton(value)).removeClass("splitDisabled");
				let item = options.items.filter(k => k.value == value)[0];
				let itemIndex = options.items.indexOf(item);
				options.items[itemIndex].enable = true;
			}
		}

		disableElementButton(value: string)
		{
			let options = this.getOptions();

			let elementButton = this.elementButton(value);
			if (elementButton == null)
			{
				this.open();
				window.setTimeout(() => this.element.find(".k-animation-container").hide(), 100);
				window.setTimeout(() =>
				{
					$(this.elementButton(value)).addClass("splitDisabled");
					let item = options.items.filter(k => k.value == value)[0];
					let itemIndex = options.items.indexOf(item);
					options.items[itemIndex].enable = false;

					this.close();
				}, 200);
			}
			else
			{
				$(this.elementButton(value)).addClass("splitDisabled");
				let item = options.items.filter(k => k.value == value)[0];
				let itemIndex = options.items.indexOf(item);
				options.items[itemIndex].enable = false;
			}
		}
		//#endregion

		//#region Open/Close
		open()
		{
			this._splitButtonMenu.element.focus();
			this._splitButtonMenu.open("#" + this.element.attr("id") + "_mn_active");
		}

		close()
		{
			this._splitButtonMenu.close("#" + this.element.attr("id") + "_mn_active");
		}
		//#endregion
	}

	SplitButton.fn = SplitButton.prototype;
	SplitButton.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
	SplitButton.fn.options.name = "SplitButton";
	kendo.ui.plugin(SplitButton);

	export class SplitButtonItem
	{
		text?: string;
		value?: string;
		icon?: string;
		imageUrl?: string;
		separator?: boolean;
		click?: (e: SplitButtonClickEvent) => void;
		color?: string;
		backgroundColor?: string;
		isPrimaryButton?: boolean;
		confirmationMessage?: string;
		visible?: boolean;
		enable?: boolean;
	}

	export class SplitButtonClickEvent
	{
		item: SplitButtonItem;
		isParent: boolean;
	}

	class SplitButtonOpenEvent
	{
		sender: KendoWidgets.SplitButton;
	}
}

interface JQuery
{
	kendoSplitButton(options?: KendoWidgets.SplitButtonOptions): JQuery;
	data(key: "kendoSplitButton"): KendoWidgets.SplitButton;
}